import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import GenericCallWidget from 'flow/components/call-components/call-widget/GenericCallWidget';
import { buildWidgetDataFromConfig } from 'flow/utils/call-widget-utils';
import PropTypes from 'prop-types';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var ConfigurableCallWidget = function ConfigurableCallWidget(_ref) {
  var config = _ref.config,
    variables = _ref.variables,
    darkMode = _ref.darkMode,
    width = _ref.width;
  var _buildWidgetDataFromC = buildWidgetDataFromConfig(config, variables),
    header = _buildWidgetDataFromC.header,
    body = _buildWidgetDataFromC.body,
    footer = _buildWidgetDataFromC.footer,
    primaryIcon = _buildWidgetDataFromC.primaryIcon;
  return /*#__PURE__*/_jsx(GenericCallWidget, {
    primaryIcon: primaryIcon,
    header: header,
    body: body,
    footer: footer,
    darkMode: darkMode,
    width: width
  });
};
ConfigurableCallWidget.propTypes = {
  config: PropTypes.shape(_objectSpread({}, GenericCallWidget.propTypes)),
  variables: PropTypes.object,
  // eslint-disable-line
  darkMode: PropTypes.bool.isRequired,
  width: PropTypes.number
};
export default /*#__PURE__*/React.memo(ConfigurableCallWidget);